import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        galleryFrame: {
            position: 'relative',
            display: 'flex',
            width: '100%',
            justifyContent: {base: 'center', lg: 'flex-start'},
            alignItems: {base: 'center', lg: 'flex-start'},
        },
        heroImageStage: {
            width: '100%',
            display: 'flex',
            justifyContent: {base: 'center', lg: 'flex-start'},
            alignItems: 'stretch',
            flex: 1,
            minWidth: 0,
        },
        heroImage: {
            //ratio: 1,
            flex: {base: '1 0 0', md: '1 0 0', lg: '1 0 0', xl: '1 0 0'},
            width: '100%',
            height: '100%',
            cursor: 'pointer',
            maxWidth: '100%',
        },
        heroImageGroup: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
            position: 'relative',
            borderRadius: 'xl',
            overflow: 'hidden',
            marginBottom: {base: 'xsmall.base', lg: 'unset'},
            width: '100%',
            sx: {
                aspectRatio: '1 / 1',
                '&:hover .gallery-nav-arrow': {
                    opacity: 1,
                },
                '&:focus-within .gallery-nav-arrow': {
                    opacity: 1,
                },
            },
        },
        heroImageSkeleton: {
            marginBottom: 'xsmall.base',
        },
        thumbnailImageList: {
            scrollBehavior: 'smooth',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: {base: 'flex-start'},
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: {base: 'row', lg: 'column'},
            width: {base: 'fit-content', lg: remCalc(84)},
            height: {base: remCalc(72), md: remCalc(82), lg: 'auto'},
            paddingBlock: remCalc(4),
            maxHeight: {base: 'unset', lg: remCalc(354)},
            overflowX: {base: 'auto', lg: 'visible'},
            overflowY: {base: 'hidden', lg: 'visible'},
            gap: {base: 'small.base', md: 'small.sm', lg: 'small.md'},
        },
        heroLeftRightArrowsContainer: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
            display: 'flex',
            height: remCalc(36),
            alignItems: 'center',
            justifyContent: 'center',
        },
        heroLeftRightArrowsContainerPrev: {
            position: 'absolute',
            left: remCalc(16),
            top: '50%',
            transform: 'translateY(-50%)',
            color: 'foreground.neutral.inverse',
            borderRadius: 'full',
            bg: 'background.base.overlay',
            boxShadow: 'borderShadow',
            backdropFilter: 'blur(5px)',
            width: remCalc(36),
            height: remCalc(36),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'small',
            borderColor: 'border.neutral.highlight',
            borderStyle: 'solid',
            // opacity: {base: 1, lg: 0},
            transition: 'background-color 0.2s ease',
            _hover: {
                bg: 'color-mix(in srgb, var(--chakra-colors-background-strong-default) 55%, transparent)',
            },
        },
        heroLeftRightArrowsContainerNext: {
            position: 'absolute',
            right: remCalc(16),
            top: '50%',
            transform: 'translateY(-50%)',
            color: 'foreground.neutral.inverse',
            borderRadius: 'full',
            bg: 'background.base.overlay',
            boxShadow: 'borderShadow',
            backdropFilter: 'blur(5px)',
            width: remCalc(36),
            height: remCalc(36),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'small',
            borderColor: 'border.neutral.highlight',
            borderStyle: 'solid',
            // opacity: {base: 1, lg: 0},
            transition: 'background-color 0.2s ease',
            _hover: {
                bg: 'color-mix(in srgb, var(--chakra-colors-background-strong-default) 55%, transparent)',
            },
        },
        heroLeftRightArrows: {
            alignItems: 'center',
            justifyContent: 'center',
            boxSize: remCalc(16),
            userSelect: 'none',
            color: 'background.neutral.grey',
        },
        bucketTabsWrapper: {
            justifyContent: 'center',
        },
        bucketTabs: {
            display: {base: 'none', md: 'none', lg: 'flex'},
            padding: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            justifyContent: 'center',
            alignItems: 'center',
            gap: 0,
            flexWrap: 'nowrap',
            bg: 'background.base.deep',
            borderRadius: 'full',
            alignSelf: 'center',
            maxWidth: '100%',
            overflow: 'hidden',
        },
        bucketTab: {
            minH: remCalc(28),
            minWidth: 0,
            flex: '1 1 auto',
            borderRadius: 'full',
            bg: 'transparent',
            color: 'text.light',
            opacity: 1,
            cursor: 'pointer',
            justifyContent: 'center',
            _hover: {
                bg: 'background.strong.default',
                color: 'foreground.neutral.inverse',
            },
        },
        bucketTabActive: {
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.neutral.highlight',
            boxShadow: 'borderShadow',

            bg: 'background.strong.default',
            color: 'foreground.neutral.inverse',
            _hover: {
                bg: 'background.strong.default',
            },
        },
        bucketTabDisabled: {
            opacity: 0.55,
        },
        bucketTabContent: {
            alignItems: 'center',
            justifyContent: 'center',
            gap: remCalc(6),
            minWidth: 0,
        },
        bucketTabLabel: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
        },
        bucketTabCounter: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
        },
        bucketTabIcon: {
            boxSize: remCalc(14),
        },
        dotsAndTabsContainer: {
            display: 'flex',
            padding: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            position: 'absolute',
            bottom: 0,
            left: 0,
            transform: 'none',
            zIndex: 3,
            width: '100%',
        },
        slideIndicatorWrapper: {
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            bg: 'transparent',
            px: ['xsmall.base', 'xsmall.base', 'xsmall.md', 'xsmall.lg'],
            py: ['xxxsmall.base', 'xxxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            borderRadius: 'full',
            alignSelf: 'center',
        },
        slideIndicator: {
            width: remCalc(6),
            height: remCalc(6),
            borderRadius: 'full',
            opacity: 1,
        },
        slideIndicatorActive: {
            width: remCalc(12),
            bg: 'background.strong.default',
        },
        slideIndicatorInactive: {
            bg: 'background.base.deep',
        },
        thumbnailImagesUpDownArrows: {
            display: {base: 'none', lg: 'flex'},
            width: remCalc(80),
            justifyContent: 'center',
            userSelect: 'none',
        },
        thumbnailImageSkeleton: {
            width: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
        },
        thumbnailVideoSkeleton: {
            height: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
            width: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
        },
        dividerContainer: {
            display: 'flex',
            justifyContent: {base: 'center', lg: 'flex-start'},
            width: {md: remCalc(70), lg: remCalc(80)},
            // height: {base: remCalc(70), lg: 'unset'},
            my: {base: 0, lg: remCalc(12)},
        },
        icon360: {
            display: 'flex',
            height: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
            width: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
            color: 'background.dark',
            justifyContent: 'center',
            alignItems: 'center',
        },
        infoLabelContainer: {
            display: 'flex',
            maxW: {base: remCalc(320), md: remCalc(386), lg: remCalc(729), xl: remCalc(729)},
            p: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            alignItems: 'flex-start',
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            position: 'absolute',
            top: 0,
            left: 0,
            transform: 'none',
            zIndex: 4,
            width: '100%',
        },
        sliderContainer: {
            w: {base: '100%', lg: 'unset'},
            maxW: {base: remCalc(395), md: remCalc(500), lg: 'unset'},
            gap: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            flexDirection: {base: 'row', lg: 'column'},
        },
        sliderBlurredContainer: {
            w: {base: '100%', lg: 'unset'},
            justifyContent: 'center',
        },
        modalOverflowTile: {
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 'large',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.neutral.highlight',
            bg: 'neutral.alphaWhite.100',
            color: 'foreground.neutral.inverse',
            textStyle: 'body-small',
            fontWeight: 'medium',
            cursor: 'pointer',
            flexShrink: 0,
        },
        inGridVideoHero: {
            width: '100%',
            height: '100%',
            minW: '100%',
            //minH: '100%',
            minWidth: 0,
            minHeight: 0,
            borderRadius: 'xl',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: '1 1 auto',
            aspectRatio: '16/9',
            '& > [data-testid="video-container"]': {
                width: '100%',
                height: '100%',
                minHeight: '100%',
                display: 'flex',
            },
            '& > [data-testid="video-container"] > div': {
                width: '100%',
                height: '100%',
                minHeight: '100%',
            },
            '& .youtube-player': {
                width: '100% !important',
                height: '100% !important',
                display: 'block',
            },
            '& .youtube-player-iframe': {
                width: '100% !important',
                height: '100% !important',
                display: 'block',
            },
            '& iframe': {
                width: '100% !important',
                height: '100% !important',
            },
        },
        videoHeroGallery: {
            width: '100%',
            height: 'auto',
            aspectRatio: '16 / 9',
            maxWidth: 'min(100%, 44rem)',
            maxHeight: 'min(56vh, 24rem)',
            margin: '0 auto',
            alignSelf: 'center',
        },
        videoHero: {
            width: '100%',
            height: '100%',
            maxW: {base: remCalc(296), sm: remCalc(378), lg: remCalc(560), xl: remCalc(729)},
            maxH: {
                base: remCalc(296),
                sm: remCalc(378),
                lg: remCalc(560),
                xl: remCalc(729),
            },
            borderRadius: 'xl',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '0 auto',
        },
        fillMediaHero: {
            width: '100%',
            height: '100%',
            minHeight: 0,
            '&.swiper-zoom-container': {
                width: '100%',
                height: '100%',
            },
        },
        fillMediaSwiperLayout: {
            height: '100%',
            '& > .swiper': {
                height: '100%',
                gap: 0,
                overflow: 'hidden',
            },
            '& > .swiper > .swiper-wrapper': {
                height: '100%',
            },
            '& .swiper-slide': {
                height: '100%',
            },
            '& .swiper-slide > .swiper-zoom-container': {
                height: '100%',
            },
        },
        fillMediaImageWrapper: {
            width: '100%',
            height: '100%',
            minHeight: 0,
            '& > img, & picture > img': {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                display: 'block',
            },
        },
        mobileMargin: {
            margin: {
                base: `${remCalc(24)} 0 ${remCalc(24)} 0`,
                lg: 0,
            },
        },
        // dynamicImage: {ratio: 1},
    },
    variants: {
        inPage: {
            thumbnailImageList: {
                margin: {
                    base: `${remCalc(24)} 0 ${remCalc(24)} 0`,
                    lg: `0 ${remCalc(24)} 0 0`,
                },
            },
            heroImage: {
                bg: 'background.base.under',
            },
            heroImageGroup: {
                justifyContent: 'center',
                alignItems: 'center',
                gap: {base: remCalc(17.5), md: 'unset', xl: remCalc(49)},
            },
        },
        inModal: {
            modalHeroStage: {
                position: 'relative',
                width: '100%',
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 0,
            },
            heroImage: {
                width: '100%',
                height: '100%',
                cursor: 'pointer',
                borderRadius: {
                    base: 0,
                    sm: 0,
                    md: 'large-1',
                    lg: 'large-1',
                    xl: 'large-1',
                },
                overflow: 'hidden',
                margin: {base: 0, sm: 0, md: '0 auto', lg: '0 auto', xl: '0 auto'},
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                maxWidth: '100%',
                maxHeight: '100%',
            },
            mobileMargin: {
                margin: 0,
            },
            heroImageGroup: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
                position: 'static',
                borderRadius: {
                    base: 0,
                    sm: 0,
                    md: 'xl',
                    lg: 'xl',
                    xl: 'xl',
                },
                flexShrink: 0,
                marginBottom: 0,
                marginInline: 'auto',
                paddingLeft: 0,
                paddingRight: 0,
                width: {
                    base: '100vw',
                    sm: '100vw',
                    md: remCalc(616),
                    lg: remCalc(625),
                    xl: remCalc(720),
                },
                height: 'auto',
                maxW: {base: '100vw', sm: '100vw', md: '100%', lg: '100%', xl: '100%'},
                maxH: 'unset',
            },
            heroLeftRightArrowsContainer: {
                position: 'static',
                top: 'unset',
                bottom: 'unset',
                transform: 'none',
                zIndex: 5,
                display: 'flex',
                width: remCalc(36),
                height: remCalc(36),
                alignItems: 'center',
                justifyContent: 'center',
                gap: remCalc(6),
                aspectRatio: '1 / 1',
                flexShrink: 0,
            },
            heroLeftRightArrowsContainerPrev: {
                position: 'absolute',
                left: {
                    base: remCalc(16),
                    sm: remCalc(16),
                    md: remCalc(40),
                    lg: remCalc(40),
                    xl: remCalc(40),
                    '2xl': remCalc(40),
                },
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                width: remCalc(36),
                height: remCalc(36),
                justifyContent: 'center',
                alignItems: 'center',
                gap: remCalc(6),
                aspectRatio: '1 / 1',
                borderRadius: 'full',
                bg: 'background.base.overlay',
                color: 'foreground.neutral.inverse',

                boxShadow: 'borderShadow',
                backdropFilter: 'blur(5px)',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.neutral.highlight',
                cursor: 'pointer',
                _hover: {
                    bg: 'color-mix(in srgb, var(--chakra-colors-background-strong-default) 55%, transparent)',
                },
            },
            heroLeftRightArrowsContainerNext: {
                position: 'absolute',
                right: {
                    base: remCalc(16),
                    sm: remCalc(16),
                    md: remCalc(40),
                    lg: remCalc(40),
                    xl: remCalc(40),
                    '2xl': remCalc(40),
                },
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                width: remCalc(36),
                height: remCalc(36),
                justifyContent: 'center',
                alignItems: 'center',
                gap: remCalc(6),
                aspectRatio: '1 / 1',
                borderRadius: 'full',
                bg: 'background.base.overlay',
                color: 'foreground.neutral.inverse',

                boxShadow: 'borderShadow',
                backdropFilter: 'blur(5px)',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.neutral.highlight',
                cursor: 'pointer',
                _hover: {
                    bg: 'color-mix(in srgb, var(--chakra-colors-background-strong-default) 55%, transparent)',
                },
            },
            heroLeftRightArrows: {
                cursor: 'pointer',
            },
            thumbnailImagesUpDownArrows: {
                display: 'none',
            },
            thumbnailImageList: {
                flexDirection: 'row',
                overflowX: 'auto',
                overflowY: 'hidden',
                justifyContent: 'flex-start',
                height: remCalc(72),
                maxHeight: remCalc(72),
                // the 4px ring padding shouldn't count toward layout, keeping the row at 64px
                marginBlock: remCalc(-4),
                gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            },
            sliderContainer: {
                display: 'flex',
                position: 'relative',
                bottom: 'unset',
                left: 'unset',
                transform: 'none',
                flexDirection: 'row',
                gap: {
                    base: 'medium.base',
                    sm: 'medium.base',
                    md: 'xsmall-1.base',
                    lg: 'xsmall-1.base',
                },
                margin: 0,
                zIndex: 1,
                alignItems: 'center',
                alignSelf: 'center',
                w: '100%',
                justifyContent: 'center',
                paddingX: ['xsmall.base', 'xsmall.base', 0, 0],
            },
            sliderBlurredContainer: {
                w: '100%',
            },
            videoHero: {
                maxWidth: {
                    base: '100%',
                    sm: '100%',
                    md: remCalc(474),
                    lg: remCalc(729),
                    xl: remCalc(768),
                },
            },
            /* dynamicImage: {
                ratio: [1, 1, 1, 807 / 768],
            }, */
        },
    },
    parts: [
        'heroImage',
        'heroImageGroup',
        'heroImageSkeleton',
        'thumbnailImageList',
        'thumbnailImagesUpDownArrows',
        'thumbnailImageSkeleton',
        'thumbnailVideoSkeleton',
        'infoLabelPrimary',
        'infoLabelTertiary',
        'dividerContainer',
        'mobileMargin',
        'icon360',
        'infoLabelContainer',
        'sliderContainer',
        'modalOverflowTile',
        'placeholderVideoHero',
        'heroLeftRightArrowsContainer',
        'heroLeftRightArrowsContainerPrev',
        'heroLeftRightArrowsContainerNext',
        'heroLeftRightArrows',
        'fillMediaHero',
        'fillMediaSwiperLayout',
        'fillMediaImageWrapper',
        'dynamicImage',
    ],
}
